import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract, SortDirection } from '../../lib';
import { MarketFacilityVersionFormDtoSchema } from '../contracts';

export type GetMarketFacilityVersionHistoryRequestDto = {
  facilityId: number;
  sortBy?: 'name' | 'submittedAt';
  sortDirection?: SortDirection;
};

const GetMarketFacilityVersionHistoryResponseDtoSchema = z.array(
  MarketFacilityVersionFormDtoSchema
);
export type GetMarketFacilityVersionHistoryResponseDto = z.infer<
  typeof GetMarketFacilityVersionHistoryResponseDtoSchema
>;

export const getMarketFacilityVersionHistory = (
  params: GetMarketFacilityVersionHistoryRequestDto,
  config?: AxiosRequestConfig
) => {
  const { facilityId, ...query } = params;
  return api
    .get(`/market-facilities/${facilityId}/history`, {
      params: {
        sortBy: query.sortBy ?? 'submittedAt',
        sortDirection: query.sortDirection ?? SortDirection.DESC,
      },
      ...config,
    })
    .then(responseContract(GetMarketFacilityVersionHistoryResponseDtoSchema));
};
